import { Component, ViewEncapsulation, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Router, NavigationExtras, RouterLink as RouterLink_1 } from '@angular/router';
import { NgIf } from '@angular/common';

interface RouterLink {
	routerLink(params: ICellRendererParams<unknown, unknown>): LinkConfig | undefined;
}

interface LinkConfig {
	commands: unknown[];
	extras?: NavigationExtras;
}

@Component({
	selector: 'copo-link-cell',
	templateUrl: './link-cell.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, RouterLink_1]
})
export class LinkCellComponent implements ICellRendererAngularComp {
	@HostBinding('class.passthrough') readonly passthrough = true;

	params?: ICellRendererParams<unknown, unknown>;
	routerLinkParams: LinkConfig | undefined;

	constructor(readonly changeDetectorRef: ChangeDetectorRef, readonly router: Router) {}

	agInit(params: ICellRendererParams<unknown, unknown>) {
		this.params = params;
		if (!params.colDef) {
			return;
		}
		const routerLinkParams = <RouterLink> params.colDef.cellRendererParams;
		this.routerLinkParams = routerLinkParams.routerLink(this.params);
		this.changeDetectorRef.markForCheck();
	}

	refresh(params: ICellRendererParams<unknown, unknown>) {
		this.params = params;
		if (!params.colDef) {
			return false;
		}
		const routerLinkParams = <RouterLink> params.colDef.cellRendererParams;
		this.routerLinkParams = routerLinkParams.routerLink(this.params);
		this.changeDetectorRef.markForCheck();
		return true;
	}
}
